export interface CategoryItem {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: CategoryItem[] = [
  {
    id: "cat-1",
    slug: "usage-guide",
    name: "使用指南",
    description: "17c一起草官网入口的详细使用教程和操作指南",
    icon: "ri-guide-line",
    articleCount: 12,
  },
  {
    id: "cat-2",
    slug: "latest-news",
    name: "最新动态",
    description: "17c一起草官方网站的最新公告、更新和行业资讯",
    icon: "ri-news-line",
    articleCount: 8,
  },
  {
    id: "cat-3",
    slug: "faq-help",
    name: "常见问题",
    description: "关于17c一起草官网入口的常见疑问与详细解答",
    icon: "ri-question-answer-line",
    articleCount: 15,
  },
  {
    id: "cat-4",
    slug: "security-tips",
    name: "安全指南",
    description: "保护账号安全，正确使用17c一起草官网入口的防护建议",
    icon: "ri-shield-keyhole-line",
    articleCount: 6,
  },
  {
    id: "cat-5",
    slug: "feature-intro",
    name: "功能介绍",
    description: "17c一起草官方网站各项功能的详细介绍和亮点展示",
    icon: "ri-stack-line",
    articleCount: 10,
  },
];

export interface ArticleItem {
  id: string;
  slug: string;
  title: string;
  summary: string;
  categoryId: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
}

export const articles: ArticleItem[] = [
  {
    id: "art-1",
    slug: "how-to-access-17c-official",
    title: "如何正确访问17c一起草官网入口 - 完整教程",
    summary: "详细介绍通过17c一起草官网入口访问官方网站的完整步骤，包括账号注册、登录流程以及常见问题解决方法，帮助新用户快速上手。",
    categoryId: "cat-1",
    categoryName: "使用指南",
    author: "17c官方团队",
    publishDate: "2026-07-28",
    readTime: "8分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20clean%20modern%20workspace%20with%20laptop%20and%20warm%20ambient%20lighting%2C%20minimalist%20desk%2C%20soft%20natural%20light%2C%20warm%20cream%20and%20beige%20tones%2C%20cozy%20professional%20atmosphere&width=800&height=400&seq=cat-art-01&orientation=landscape",
    tags: ["17c一起草官网入口", "使用教程", "新手入门"],
  },
  {
    id: "art-2",
    slug: "17c-new-features-2026",
    title: "17c一起草官方网站2026年全新功能重磅上线",
    summary: "17c一起草官方网站迎来重大更新，全新界面设计、性能优化和多项创新功能，为用户带来前所未有的使用体验。",
    categoryId: "cat-2",
    categoryName: "最新动态",
    author: "17c官方团队",
    publishDate: "2026-07-25",
    readTime: "5分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20bright%20modern%20office%20space%20with%20natural%20light%2C%20clean%20white%20desk%20with%20monitor%2C%20plant%2C%20and%20coffee%2C%20warm%20beige%20and%20cream%20tones%2C%20professional%20atmosphere&width=800&height=400&seq=cat-art-02&orientation=landscape",
    tags: ["17c一起草官方网站", "功能更新", "2026新版"],
  },
  {
    id: "art-3",
    slug: "account-security-protection",
    title: "17c一起草官网入口账号安全防护全攻略",
    summary: "全面解析如何保护您的17c一起草账号安全，包括密码设置建议、二次验证开启、异常登录检测等核心安全功能的使用方法。",
    categoryId: "cat-4",
    categoryName: "安全指南",
    author: "安全团队",
    publishDate: "2026-07-20",
    readTime: "10分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20secure%20digital%20workspace%20concept%20with%20shield%20icon%20on%20screen%2C%20warm%20ambient%20lighting%2C%20minimalist%20desk%20setup%2C%20clean%20cream%20and%20beige%20aesthetic&width=800&height=400&seq=cat-art-03&orientation=landscape",
    tags: ["17c一起草官网入口", "账号安全", "防护指南"],
  },
  {
    id: "art-4",
    slug: "common-login-problems",
    title: "17c一起草官网入口登录常见问题与解决方案",
    summary: "汇总用户在登录17c一起草官方网站时遇到的各种常见问题，提供详细的排查步骤和快速解决方案，让您轻松解决登录困扰。",
    categoryId: "cat-3",
    categoryName: "常见问题",
    author: "客服团队",
    publishDate: "2026-07-18",
    readTime: "6分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20help%20desk%20concept%20with%20support%20icons%20on%20screen%2C%20warm%20lighting%2C%20minimalist%20workspace%2C%20clean%20professional%20setup%20with%20cream%20and%20beige%20tones&width=800&height=400&seq=cat-art-04&orientation=landscape",
    tags: ["17c一起草登录地址", "登录问题", "故障排除"],
  },
  {
    id: "art-5",
    slug: "mobile-optimization-guide",
    title: "17c一起草官网入口移动端最佳使用体验指南",
    summary: "针对移动设备用户的使用指南，介绍如何在手机上获得最佳的17c一起草官网入口访问体验，包括浏览器推荐和设置优化建议。",
    categoryId: "cat-1",
    categoryName: "使用指南",
    author: "17c官方团队",
    publishDate: "2026-07-15",
    readTime: "7分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20on%20a%20clean%20desk%20with%20warm%20lighting%2C%20minimalist%20aesthetic%2C%20cream%20and%20beige%20background%2C%20professional%20mobile%20workspace&width=800&height=400&seq=cat-art-05&orientation=landscape",
    tags: ["17c一起草官网入口", "移动端", "使用体验"],
  },
  {
    id: "art-6",
    slug: "platform-comparison-2026",
    title: "17c一起草官网入口与其他平台的对比分析",
    summary: "从功能、稳定性、安全性、用户体验等多个维度，客观对比17c一起草官方网站与同类平台的优势和特色。",
    categoryId: "cat-5",
    categoryName: "功能介绍",
    author: "17c官方团队",
    publishDate: "2026-07-12",
    readTime: "9分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20comparison%20concept%20with%20two%20screens%20side%20by%20side%2C%20warm%20lighting%2C%20minimalist%20workspace%2C%20professional%20atmosphere%20with%20cream%20and%20beige%20tones&width=800&height=400&seq=cat-art-06&orientation=landscape",
    tags: ["17c一起草官方网站", "平台对比", "功能分析"],
  },
  {
    id: "art-7",
    slug: "mirror-access-methods",
    title: "17c一起草官网入口镜像通道使用方法详解",
    summary: "当主入口访问缓慢时，如何通过备用镜像通道快速访问17c一起草官方网站，确保您在任何网络环境下都能稳定连接。",
    categoryId: "cat-1",
    categoryName: "使用指南",
    author: "17c官方团队",
    publishDate: "2026-07-08",
    readTime: "5分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20mirror%20reflection%20concept%20on%20a%20laptop%20screen%2C%20warm%20natural%20lighting%2C%20minimalist%20desk%20with%20clean%20cream%20and%20beige%20aesthetic%2C%20professional%20setup&width=800&height=400&seq=cat-art-07&orientation=landscape",
    tags: ["17c一起草最新入口", "镜像通道", "访问技巧"],
  },
  {
    id: "art-8",
    slug: "phishing-prevention-tips",
    title: "警惕仿冒网站：如何识别真正的17c一起草官网入口",
    summary: "详细介绍识别假冒17c一起草官方网站的方法，帮助用户避免钓鱼网站陷阱，确保始终通过正确的17c一起草官网入口进行访问。",
    categoryId: "cat-4",
    categoryName: "安全指南",
    author: "安全团队",
    publishDate: "2026-07-05",
    readTime: "8分钟",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20warning%20sign%20concept%20with%20phishing%20hook%20on%20screen%2C%20warm%20lighting%2C%20minimalist%20workspace%2C%20clean%20professional%20atmosphere%20with%20cream%20and%20beige%20tones&width=800&height=400&seq=cat-art-08&orientation=landscape",
    tags: ["17c一起草官网入口", "防钓鱼", "安全识别"],
  },
];